import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrSpinnerButtonDirective } from './tr-spinner-button.directive';

@NgModule({
  imports: [ CommonModule ],
  exports: [ TrSpinnerButtonDirective ],
  declarations: [ TrSpinnerButtonDirective ],
})
export class TrSpinnerButtonDirectiveModule {}
